<template>
    <div class="layer" v-show="isShow">
        <div class="mask" @click="goShow"></div>
        <div class="content">
            <img src="../../assets/share.png"/>
        </div>
    </div>
</template>

<script>
  import { Toast, MessageBox } from 'mint-ui'
  import config from '../../common/config.js'
  import store from '../../store'

  let wx = require('weixin-js-sdk')
  export default {
    name: "share",
    store: store,
    props: {
      isShow: {
        type: Boolean,
        default: false
      },
      isUrl: {
        type: String,
        default: ''
      },
      shareMsg: {
        type: String,
        default: ''
      }
    },
    data () {
      return {}
    },
    mounted () {
      this.goyanzheng()
    },
    watch: {
      isShow () {
        if (this.isShow) {
          this.goyanzheng()
        }
      },
      isUrl () {
        console.log(this.isUrl)
        this.goyanzheng()
      }
    },
    methods: {
      goShow () {
        this.$emit('showfalse')
      },
      goyanzheng () {
        let that = this
        this.$g.ajax({
          path: 'uploaders/jssdksign',
          method: 'post',
          data: {
            url: location.href.split('#')[0]
          },
          cbSuccess (data) {
            that.begin(data.memo.nonceStr, data.memo.signature, data.memo.timestamp)
          },
          cbError (error) {
            let msg = error.msg
            Toast({
              message: msg,
              position: 'bottom',
              duration: 1500
            })
          }
        })
      },
      begin (nonceStr, signature, timestamp) {
        this.$emit('sharesucc')
        let that = this
        let activityView = JSON.parse(sessionStorage.getItem('activityView'))
        let shareWxLink = this.isUrl === '' ? config.host + '?id=' + activityView.id : config.host + this.isUrl
        console.log(activityView.id)
        wx.config({
          debug: false,
          appId: 'wx97dae6033b09528a',
          timestamp: timestamp,
          nonceStr: nonceStr,
          signature: signature,
          jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareTimeline', 'onMenuShareAppMessage']
        })
        wx.ready(function () {
          wx.updateAppMessageShareData({
            title: that.shareMsg === '' ? activityView.title : that.shareMsg, // 分享标题
            desc: activityView.share_text !== null ? activityView.share_text : activityView.title, // 分享描述
            link: shareWxLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: activityView.banner.length > 0 ? activityView.banner[0].src : '' , // 分享图标
            success: function () {
              // that.$emit('shareok')
              // 设置成功
              //   alert('分享给朋友,分享到QQ,设置成功')
            }
          })
          wx.updateTimelineShareData({
            title: that.shareMsg === '' ? activityView.title : that.shareMsg, // 分享标题
            link: shareWxLink,// 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: activityView.banner.length > 0 ? activityView.banner[0].src : '' , // 分享图标
            success: function () {
              // 设置成功
              // alert('分享到朋友圈,分享到QQ空间,设置成功')
            }
          })
        })
        wx.onMenuShareTimeline({
          title: that.shareMsg === '' ? activityView.title : that.shareMsg, // 分享标题
          link: shareWxLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: activityView.banner.length > 0 ? activityView.banner[0].src : '' , // 分享图标
          success: function () {
            // 用户点击了分享后执行的回调函数
          }
        })
        wx.onMenuShareAppMessage({
          title: that.shareMsg === '' ? activityView.title : that.shareMsg, // 分享标题
          desc: activityView.share_text !== null ? activityView.share_text : activityView.title, // 分享描述
          link: shareWxLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: activityView.banner.length > 0 ? activityView.banner[0].src : '' ,
          type: '', // 分享类型,music、video或link，不填默认为link
          dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
          success: function () {
            // 用户点击了分享后执行的回调函数
          }
        })
        wx.error(function (res) {
          console.log(res)
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
    .layer {
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        z-index: 999;
        .mask {
            background: rgba(0, 0, 0, 0.6);
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            z-index: 1;
        }
        .content {
            position: relative;
            width: 250px;
            background: #fff;
            margin: 20% auto;
            z-index: 2;
            padding: 30px;
            img{
                width: 100%;
            }
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/public/share.vue